import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar/Sidebar';
import { SidebarProvider } from './sidebar/SidebarContext';
import { MobileBottomNav } from './navigation/MobileBottomNav';
import { usePendingPaymentConfirmation } from '@/src/modules/purchase/usePendingPaymentConfirmation';
import { PendingPaymentsBanner } from '@/src/modules/purchase/components/PendingPaymentsBanner';
import { Footer } from './Footer';

export function DashboardLayout() {
  // Paid but the checkout page was lost before Razorpay's callback → confirm
  // with the backend on every dashboard load, and tell the user (2026-09-24).
  const { confirmed, dismiss } = usePendingPaymentConfirmation();
  return (
    <SidebarProvider>
      <div className="flex h-screen overflow-hidden bg-surface">
        <Sidebar />
        <main className="flex-1 overflow-y-auto overflow-x-hidden pb-16 md:pb-0">
          <PendingPaymentsBanner confirmed={confirmed} onDismiss={dismiss} />
          <Outlet />
        </main>
        <MobileBottomNav />
      </div>
    </SidebarProvider>
  );
}

export function SiteLayout() {
  return (
    <div className="force-light min-h-screen flex flex-col bg-surface overflow-x-hidden">
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
